module.exports = __webpack_public_path__ + "public/img/night.7b94d17b.png";